import { OtpCodeCard } from './view';

export { default as OtpCodeReducer } from './reducer';
export { default as OtpCodeSaga } from './saga';

export default OtpCodeCard;
